import {UserSettings} from '@package/shared'
import type {z} from 'zod'

export const FormValues = UserSettings.pick({
  timezone: true,
  firstDayOfWeek: true,
  timeFormat: true,
})
export type FormValues = z.infer<typeof FormValues>
